import React, { useEffect,useRef } from 'react';
import { Box,Button,Stack,Typography } from '@mui/material';
import { alpha,useTheme } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import { servicioItem } from './rafagaModel';
export default function BotonRafaga({ acceso,disabled,onAdd,onEdit }) {
  const theme=useTheme();
  const color=/^#[0-9a-f]{6}$/i.test(acceso.color || '') ? acceso.color : theme.palette.primary.main;
  const timer=useRef(null),held=useRef(false);
  const cancel=() => { clearTimeout(timer.current);timer.current=null; };
  useEffect(() => () => clearTimeout(timer.current),[]);
  return <Button variant="outlined" title={acceso.etiqueta} disabled={disabled || !Number(acceso.activo)}
    onPointerDown={(e) => { if(e.button!==0) return;held.current=false;timer.current=setTimeout(() => {held.current=true;onEdit(servicioItem(acceso));},500); }}
    onPointerUp={cancel} onPointerLeave={cancel} onPointerCancel={cancel} onContextMenu={(e) => e.preventDefault()}
    onClick={() => {cancel();if(held.current) {held.current=false;return;}onAdd(servicioItem(acceso));}}
    sx={{width:'100%',maxWidth:180,minWidth:0,height:acceso.grupo==='PRINCIPAL' ? 92 : 82,
      borderRadius:2,borderColor:alpha(color,.22),borderTop:`3px solid ${alpha(color,.7)}`,
      backgroundColor:alpha(color,theme.palette.mode==='dark' ? .12 : .04),color:'text.primary',
      px:1.5,py:1.25,textTransform:'none',textAlign:'left',touchAction:'manipulation',userSelect:'none',
      transition:'background-color 150ms, border-color 150ms, box-shadow 150ms',
      '&:hover':{backgroundColor:alpha(color,.1),borderColor:alpha(color,.55),boxShadow:`0 3px 10px ${alpha(color,.1)}`},
      '&.Mui-focusVisible':{outline:`2px solid ${color}`,outlineOffset:2}}}>
    <Stack justifyContent="space-between" width="100%" height="100%" spacing={.75}>
      <Typography fontWeight={650} fontSize={13} lineHeight={1.3}
        sx={{display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',overflow:'hidden',overflowWrap:'anywhere'}}>{acceso.etiqueta}</Typography>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={.5}>
        <Typography fontSize={13} fontWeight={750} sx={{whiteSpace:'nowrap'}}>Q {Number(acceso.precio_base).toFixed(2)}<Box component="span" sx={{fontSize:10,fontWeight:400,color:'text.secondary'}}> / ud.</Box></Typography>
        <AddIcon aria-hidden="true" sx={{fontSize:18,color,flexShrink:0}} />
      </Stack>
    </Stack>
  </Button>;
}
